import { Helmet } from 'react-helmet-async';

import { PermissionRequestView } from 'src/sections/system/permissions';

// ----------------------------------------------------------------------

export default function PermissionRequestPage() {
  return (
    <>
      <Helmet>
        <title>Permissions Required | PointCraft</title>
      </Helmet>

      <PermissionRequestView />
    </>
  );
}
